<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<section class="section is-main-section">
			<card-component title="" icon="">
				<b-field label="チーム名"
					horizontal
					custom-class="require"
					:type="{ 'is-danger': $utils.hasError(errors, 'name') }"
					:message="errors.name">
					<b-input type="text" v-model="name" />
				</b-field>

				<b-field label="フリガナ"
					horizontal
					custom-class="require"
					:type="{ 'is-danger': $utils.hasError(errors, 'nameKana') }"
					:message="errors.nameKana">
					<b-input type="text" v-model="nameKana" />
				</b-field>

				<b-field label="説明"
					horizontal>
					<b-input type="textarea" v-model="detail" />
				</b-field>

				<b-field label="組織"
					horizontal
					:type="{ 'is-danger': $utils.hasError(errors, 'organization') }"
					:message="errors.organization">
					<b-input type="text" v-model="organization" />
				</b-field>

				<b-field label="ユニット"
					horizontal
					:type="{ 'is-danger': $utils.hasError(errors, 'unit') }"
					:message="errors.unit">
					<b-input type="text" v-model="unit" />
				</b-field>

				<b-field label="チーム画像" horizontal>
					<div>
						<img class="preview" :src="imageBase" v-show="!image" :style="{ 'max-width': previewW + 'px' }">
						<image-picker :previewUrl="image" :isLoading="isImageLoading" :previewW="previewW" @file-change="onImageChange" @delete="onImageDelete"></image-picker>
					</div>
				</b-field>

				<b-field label="主催者"
					custom-class="require"
					horizontal>
					<b-select v-model="staffId">
						<option v-for="(row, index) in staffs" :key="index" :value="row.id">
							{{ row.name }}
						</option>
					</b-select>
				</b-field>

				<b-field v-if="id" style="margin-top: -20px;" label=""
					horizontal>
					<div>※チーム内のメンバーのみ主催者になることができます</div>
				</b-field>

				<b-field class="mt-40" horizontal>
					<div>
						<b-button @click="$router.go(-1)">戻る</b-button>
						<b-button type="is-primary" class="ml-50" :loading="isLoading" @click="onSubmitClick">{{ !id ? '登録' : '更新' }}</b-button>
					</div>
				</b-field>
			</card-component>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.preview {
	height: auto;
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import mapValues from 'lodash/mapValues'
import CheckboxPicker from '@/components/CheckboxPicker'
import RadioPicker from '@/components/RadioPicker'
import ImagePicker from '@/components/ImagePicker'
import DatePicker from '@/components/DatePicker'

export default {
	name: 'Forms',
	components: {
		ImagePicker,
		RadioPicker,
		CheckboxPicker,
		CardComponent,
		TitleBar,
		DatePicker,
	},
	data () {
		return {
			id: '',
			name: '',
			nameKana: '',
			detail: '',
			organization: '',
			unit: '',
			image: '',
			imageBase: '',
			errors: {
				name: '',
				nameKana: '',
				organization: '',
				unit: '',
			},
			isLoading: false,
			isImageLoading: false,
			previewW: 200,
			staffs: [],
			staffId: '',
		}
	},
	computed: {
		titleStack () {
			return [
				'チーム登録',
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		onImageDelete: function() {
			this.image = '';
		},
		onImageChange: function(file) {
			this.uploadImage(file);
		},
		uploadImage: async function(file, key) {
			this.isImageLoading = true;

			let data = {
				"image": file,
			};
			let ep = 'teams/image';

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.image = res.data.url;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isImageLoading = false;
			}
		},
		onSubmitClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"name": this.name,
				"organization": this.organization,
				"unit": this.unit,
				"name_kana": this.nameKana,
				"detail": this.detail,
				"image": this.image,
				"staff_id": this.staffId,
			};

			this.$utils.log(data);

			try {
				let ep = 'teams';
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('データを更新しました');
				this.$router.push({ name: 'team' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let params = this.$route.params.teamId ? '/' + this.$route.params.teamId: '';
			let ep = 'teams/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.name = res.data.name;
				this.nameKana = res.data.name_kana;
				this.organization = res.data.organization;
				this.unit = res.data.unit;
				this.detail = res.data.detail;
				this.image = res.data.image;
				this.imageBase = res.data.image_base;
				this.staffs = res.data.staffs;
				this.staffId = res.data.staff_id || this.staffs[0].id;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
